import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    Grid,
    withTheme,
    Button,
    DialogActions
} from '@material-ui/core';
import groupBy from 'lodash/groupBy';
import { formatMoney } from '../../utils';
import ReadonlyEditor from '../drafteditor/components/ReadonlyEditor';

function AvailableAddonsModal({ addons, showModal, MODAL_TYPE }) {
    /**
     * addons here is a simple list with items, like:
     * [{"id":155,"name":"Titleist Women's R","retail_price":85,"groupname":"Golf Clubs"}, ...
     */
    const groupedAddons = groupBy(addons, item => item?.group?.id);

    return (
        <Dialog
            open
            onClose={() => {
                showModal(MODAL_TYPE.NONE);
            }}
        >
            <DialogTitle className="title">Available Add-Ons</DialogTitle>
            <div className="modal-content">
                <DialogContent style={{ overflow: 'hidden' }}>
                    <Grid container spacing={2}>
                        {Object.keys(groupedAddons).map(group => {
                            const addonsInGroup = groupedAddons[group];
                            const firstAddon = addonsInGroup[0];
                            return (
                                <Grid
                                    key={group}
                                    className="addon mb-2"
                                    item
                                    container
                                    xs={12}
                                    direction="column"
                                >
                                    <Grid item className="addon-image mb-2">
                                        <img src={firstAddon.group?.image} alt="" />
                                    </Grid>
                                    <Grid item className="addon-name">
                                        <h2>{firstAddon.group?.name}</h2>
                                    </Grid>
                                    <Grid item style={{ paddingBottom: '10px' }}>
                                        <ReadonlyEditor value={firstAddon.group?.description} />
                                    </Grid>
                                    <Grid item>
                                        <span className="mb-2">Options:</span>
                                        <ul>
                                            {addonsInGroup.map(ticket => (
                                                <li key={ticket.id}>
                                                    {ticket.name}
                                                    {ticket.retail_price
                                                        ? ` - ${formatMoney(ticket.retail_price)}`
                                                        : ''}
                                                </li>
                                            ))}
                                        </ul>
                                    </Grid>
                                </Grid>
                            );
                        })}
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button
                        variant="contained"
                        fullWidth
                        onClick={() => {
                            showModal(false);
                        }}
                    >
                        Close
                    </Button>
                </DialogActions>
            </div>
        </Dialog>
    );
}

export default withTheme(AvailableAddonsModal);
